import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import fixLink from 'src/utils/fix_link';

const Link = ({ children, to, ...params }: any) => {
	const { i18n } = useTranslation();

	const path: string = fixLink(to, i18n);

	return (
		<RouterLink to={path} {...params}>
			{children}
		</RouterLink>
	);
};

export default Link;
